import { render } from "./pageBottom.vue?vue&type=template&id=e77bdd78&scoped=true"
const script = {}

import "./pageBottom.vue?vue&type=style&index=0&id=e77bdd78&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77bdd78"]])

export default __exports__